<div class="threshold-chart-container">
  <!-- Slider Section -->
  <div class="slider-section">
    <div class="slider-label">
      <span class="label-text">
        Threshold Performance Analysis
        <svg-icon
          src="assets/icons/circle-question.svg"
          class="title-icon"
          [title]="
            'The probability that the ML prediction will outperform the baseline/legacy prediction. Threshold determines the minimum predicted probability required to use ML instead of baseline.'
          "
          [attr.aria-label]="'Threshold Information'"
        >
        </svg-icon>
      </span>
    </div>
    <div class="slider-div">
      <nz-slider
        #sliderRef
        [nzMin]="sliderMin"
        [nzMax]="sliderMax"
        [nzStep]="sliderStep"
        [(ngModel)]="sliderValue"
        (ngModelChange)="onSliderChange($event)"
        [nzTooltipVisible]="'never'"
        [nzTipFormatter]="formatSliderTooltip"
        class="threshold-slider"
      ></nz-slider>
      <div class="slider-percentage-box" *ngIf="chartWidth === 'chart-large'">
        <span class="percentage-value">{{ (sliderValue * 100).toFixed(0) }}</span>
        <span class="percentage-symbol">%</span>
      </div>
    </div>
  </div>

  <!-- Chart Section -->
  <div class="chart-section">
    <highcharts-chart [options]="chartOptions" class="threshold-highchart"></highcharts-chart>

    <!-- Metric Cards Section (Inside Chart) -->
    <div class="metrics-section" [class.chart-large]="chartWidth === 'chart-large'">
      <div class="metric-card adoption-card">
        <div class="card-label">TRANSACTION AFFECTED</div>
        <div class="card-value">{{ currentAdoptionRate.toFixed(1) }}%</div>
      </div>

      <div class="metric-card performance-card">
        <div class="card-label">PREDICTED PROBABILITY<br />THRESHOLD</div>
        <div class="card-value">{{ currentAvgPerformanceScore.toFixed(1) }} %</div>
      </div>

      <div class="metric-card RmseChange-card">
        <div class="card-label">RMSE CHANGE</div>
        <div class="card-value">{{ currentRmseChange.toFixed(1) }} %</div>
      </div>
    </div>
  </div>
</div>
